import { Timestamp } from "@firebase/firestore"
import { TimestampData } from "@/support/dates"
import { parseISO } from "date-fns"

export type MaybeTimestamp = Timestamp | TimestampData | string

export function toTimestamp(maybeTimestamp: MaybeTimestamp) {
  if (typeof maybeTimestamp === "string") {
    return Timestamp.fromDate(parseISO(maybeTimestamp))
  } else if (maybeTimestamp instanceof Timestamp) {
    return maybeTimestamp
  } else {
    return new Timestamp(maybeTimestamp._seconds, maybeTimestamp._nanoseconds)
  }
}
